export const version = "properties/5.0.6";
//# sourceMappingURL=_version.js.map